import * as React from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import { IReference } from "../../../models/profile";
import { ILocalization } from "../../../models/localization";
import SeekerStore from "../../../stores/seekerStore";
import { Grid, Row, Col } from "react-flexbox-grid";
import TextField from "material-ui/TextField";
import * as s from "./reference.css";

export enum RefField {
  Name = 1,
  Title = 2,
  Phone = 3,
  Contact = 4
}
@observer
export default class ReferenceEditor extends React.Component<{ store: SeekerStore, reference: IReference, onChange: (val: string, fld: RefField) => void }, {}> {
  @observable name: string;
  @observable title: string;
  @observable phone: string;
  @observable contact: string;
  constructor(props: any) {
    super(props);
    this.name = props.reference.refName || "";
    this.title = props.reference.refTitle || "";
    this.phone = props.reference.refPhone || "";
    this.contact = props.reference.refContact || "";
  }
  @action handleNameChange = event => {
    this.name = event.target.value;
    this.props.onChange(this.name, RefField.Name);
  }
  @action handleTitleChange = event => {
    this.title = event.target.value;
    this.props.onChange(this.title, RefField.Title);
  }
  @action handlePhoneChange = event => {
    this.phone = event.target.value;
    this.props.onChange(this.phone, RefField.Phone);
  }
  @action handleContactChange = event => {
    this.contact = event.target.value;
    this.props.onChange(this.contact, RefField.Contact);
  }
  @action componentWillReceiveProps(nextProps): void {
    this.name = nextProps.reference.refName || "";
    this.title = nextProps.reference.refTitle || "";
    this.phone = nextProps.reference.refPhone || "";
    this.contact = nextProps.reference.refContact || "";
  }
  render(): JSX.Element {
    const flds: ILocalization = this.props.store.localization.fields;
    return (
      <div>
        <p className={s.smallText} style={{ marginBottom: "10px" }}>{flds.addJob.refHeader}</p>
        <Row>
          <Col xs={12} className={s.col}>
            <TextField label={flds.addJob.ref} value={this.name} onChange={this.handleNameChange} fullWidth />
          </Col>
          <Col xs={12} className={s.col}>
            <TextField label={flds.addJob.refTitle} value={this.title} onChange={this.handleTitleChange} fullWidth />
          </Col>
          <Col xs={12} className={s.col}>
            <TextField label={flds.addJob.refPhone} value={this.phone} onChange={this.handlePhoneChange} fullWidth />
          </Col>
          <Col xs={12} className={s.col}>
            <TextField label={flds.addJob.refContact} value={this.contact} onChange={this.handleContactChange} fullWidth />
          </Col>
        </Row>
      </div>);
  }
}


// WEBPACK FOOTER //
// ./src/components/profile/referenceEditor/index.tsx